/**
 * Orientation of the screen
 * @readonly
 * @enum {string}
 */
export enum ScreenOrientation {
    /**
     * Horizontal orientation where screen width is bigger than screen height
     */
    HORIZONTAL = 'horizontal',
    /**
     * Vertical orientation where screen height is bigger than screen width
     */
    VERTICAL = 'vertical'
}
